export const hamburger = {
	name: 'hamburger',
	title: 'Menu',
	content:
		'<path d="M 2.25,18.003h19.5 " stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round"	stroke-linejoin="round"></path><path d="M 2.25,12.003h19.5 " stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M 2.25,6.003h19.5" stroke="currentColor" fill="none" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>',
};
